// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4856":"68bca319","7137":"d0b12844","7191":"68bca319"}[chunkId] + ".chunk.css";
};